import Main from '@/view/main'
import cms from './routes/cms.js'
import sys from './routes/system.js'
import member from './routes/member.js'
import message from './routes/message'
import tender from './routes/tender.js'
import pm from './routes/pm'
import sa from './routes/sa'
import config from '@/config'
import pam from './routes/pam'
import fund from './routes/fund'
import business from './routes/business'
import secondhand from './routes/secondhand'
import appVersion from './routes/appVersion'
import integral from './routes/integral'
// 自营商城
// import selfPm from './routes/self/pm'
// import selfPur from './routes/self/purchase'
import v5 from './routes/v5'
/**
 * meta可配置的参数:
 * meta: {
 *  title: 面包削文字
 *  hide: 是否在面包削隐藏
 *  noAuth: 不需要权限控制（比白名单还牛逼）
 * }
 */
export default [
  {
    path: '/login',
    name: 'login',
    meta: {
      title: '登录',
      noAuth: true
    },
    component: () => import('@/view/main/login.vue')
  },
  {
    path: '/demo',
    name: 'demo',
    meta: {
      noAuth: true
    },
    component: () => import('@/view/demo')
  },
  {
    path: '/',
    meta: {
      hide: true,
      ignoreBreadCrumb: true
    },
    redirect: `/${config.modules.OM.prefix}`
  },
  {
    path: `/${config.modules.OM.prefix}`, // 运营模块
    meta: {
      hide: true,
      ignoreBreadCrumb: true
    },
    component: Main,
    children: [
      {
        path: '/om',
        name: 'home',
        meta: {
          title: '首页',
          home: true,
          hide: true,
          ignoreBreadCrumb: true
        },
        component: () => import('@/view/main/home')
      },
      cms,
      member,
      tender,
      pm,
      sa,
      pam,
      message,
      fund,
      business,
      secondhand,
      appVersion,
      integral
    ]
  },
  {
    path: `/${config.modules.SELF.prefix}`, // 自营模块
    meta: {
      hide: true,
      ignoreBreadCrumb: true
    },
    component: Main,
    children: [
      {
        path: '',
        name: 'self-home',
        meta: {
          title: '首页',
          home: true, // 首页
          hide: true,
          ignoreBreadCrumb: true
        },
        component: () => import('@/view/v5')
      },
      v5.pm, // 商品管理
      v5.purchase, // 采购管理
      v5.order, // 订单管理
      v5.mall, // 店铺管理
      v5.sales, // 销售管理
      v5.information, // 客户管理
      v5.statement, // 对账管理
      v5.statistics, // 统计分析
      v5.collect, // 集采管理
      v5.account, // 应收账流水
      v5.secondhand, // 二手交易
      v5.report, // 报表统计
      v5.push, // 财务推送
      v5.inputInvoice, // 进项发票
      v5.outputInvoice, //销项发票
      v5.salesContracts //销项发票
    ]
  },
  {
    path: '', // 公共模块
    meta: {
      hide: true,
      ignoreBreadCrumb: true
    },
    component: Main,
    children: [sys]
  }, // 系统管理 公共模块
  {
    path: '/pdf',
    name: 'pdf',
    meta: {
      title: 'pdf预览',
      noAuth: true
    },
    component: () => import('@/view/pdf/index.vue')
  },
  {
    path: '/401',
    name: 'error_401',
    meta: {
      title: '401',
      noAuth: true
    },
    component: () => import('@/view/error-page/401.vue')
  },
  {
    path: '/500',
    name: 'error_500',
    meta: {
      title: '500',
      noAuth: true
    },
    component: () => import('@/view/error-page/500.vue')
  },
  {
    path: '*',
    name: 'error_404',
    meta: {
      title: '404',
      noAuth: true
    },
    component: () => import('@/view/error-page/404.vue')
  }
]



// WEBPACK FOOTER //
// ./src/router/routers.js